import { Channel, ChannelFilters, Idea } from '@frontend/data-access';
import { RootState } from './settings/store';
import { KanbanLoadingStates } from './ideaChannelSlice';

export const selectChannel = (state: RootState): Channel | null =>
  state.ideaChannel.channel;

export const selectChannelFilters = (state: RootState): ChannelFilters | null =>
  state.ideaChannel.filters;

export const selectIdeaSortby = (state: RootState): 'ASC' | 'DESC' =>
  state.ideaChannel.ideaSortby;

export const selectAllIdeas = (state: RootState): Idea[] =>
  state.ideaChannel.allIdeas;

export const selectLoadingStates = (state: RootState): KanbanLoadingStates =>
  state.ideaChannel.loadingStates;
